import React from 'react';
import { PASSWORD_RULES } from '../../../utils/passwordPolicy';

interface PasswordRequirementsProps {
  password: string;
}

/** The pool's password rules, each marked as met or not for the password typed so far. */
const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ password }) => (
  <div className="text-xs text-gray-500" data-testid="password-requirements">
    <p>Password must include:</p>
    <ul className="pl-4 mt-1 space-y-0.5">
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(password);
        return (
          <li key={rule.id} className={met ? 'text-green-600' : password ? 'text-red-500' : ''}>
            <span aria-hidden="true">{met ? '✓' : '•'}</span> {rule.label}
            <span className="sr-only">{met ? ' (met)' : ' (not met)'}</span>
          </li>
        );
      })}
    </ul>
  </div>
);

export default PasswordRequirements;
